import { createContext, useContext, useState, useEffect } from "react";
import { translations, languages } from "@/lib/translations";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState("en");
  const [showLanguageModal, setShowLanguageModal] = useState(false);

  useEffect(() => {
    // Check if user has previously selected a language
    const savedLanguage = localStorage.getItem("preferred_language");
    const hasSeenModal = localStorage.getItem("has_seen_language_modal");

    if (savedLanguage) {
      setLanguage(savedLanguage);
    }

    // Show modal on first visit
    if (!hasSeenModal) {
      setShowLanguageModal(true);
    }
  }, []);

  const changeLanguage = (langCode) => {
    setLanguage(langCode);
    localStorage.setItem("preferred_language", langCode);
    localStorage.setItem("has_seen_language_modal", "true");
  };

  const openLanguageModal = () => {
    setShowLanguageModal(true);
  };

  const closeLanguageModal = () => {
    setShowLanguageModal(false);
    localStorage.setItem("has_seen_language_modal", "true");
  };

  const t = translations[language] || translations.en;

  return (
    <LanguageContext.Provider
      value={{
        language,
        changeLanguage,
        t,
        languages,
        showLanguageModal,
        openLanguageModal,
        closeLanguageModal
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};
